import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { AirplaneTilt, ArrowRight } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { api } from "../lib/api";
import { Reveal } from "./Reveal";

export const AirportTransfers = () => {
  const { t } = useLang();
  const a = t.airport;
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    api.get("/airport-rates").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const book = (route, airport) => {
    sessionStorage.setItem("prefill-booking", JSON.stringify({ pickup: route.city_label + ", Belgique", dropoff: airport.airport_label }));
    navigate("/vehicules");
  };

  if (!data) return null;
  const airports = data.airports;
  const current = airports[active];

  return (
    <section id="airport" className="cfg relative py-16 md:py-24 bg-white" data-testid="airport-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-10">
          <div>
            <Reveal>
              <p className="cfg-body text-[12px] font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-3">{a.overline}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="cfg-display text-3xl md:text-5xl text-[#071B2F] tracking-tight max-w-2xl">{a.title}</h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="cfg-body text-[#071B2F]/55 max-w-sm md:text-right">{a.sub}</p>
          </Reveal>
        </div>

        <div className="flex flex-wrap gap-3 mb-8">
          {airports.map((ap, i) => (
            <button key={ap.airport} onClick={() => setActive(i)} data-testid={`airport-tab-${ap.airport}`}
              className={`cfg-body inline-flex items-center gap-2 text-[13px] px-5 py-3 rounded-full border transition-colors ${active === i ? "border-[#D4AF37] text-[#a9862a] bg-[#D4AF37]/8" : "border-[#071B2F]/12 text-[#071B2F]/60 hover:border-[#071B2F]/40"}`}>
              <AirplaneTilt weight="light" size={16} />{ap.airport_label}
            </button>
          ))}
        </div>

        <motion.div key={current.airport} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {current.routes.map((r) => (
            <div key={r.city} className="group rounded-[24px] border border-[#071B2F]/10 bg-white p-7 hover:border-[#D4AF37]/50 shadow-[0_20px_50px_-35px_rgba(7,27,47,0.35)] transition-colors flex flex-col" data-testid={`airport-route-${current.airport}-${r.city}`}>
              <p className="cfg-body text-[10px] tracking-[0.2em] uppercase text-[#071B2F]/40">{a.from}</p>
              <h3 className="cfg-display text-3xl text-[#071B2F] mt-1">{r.city_label}</h3>
              <div className="mt-5 flex items-end justify-between">
                <div>
                  <p className="cfg-body text-[9px] tracking-[0.2em] uppercase text-[#071B2F]/40">{a.oneway}</p>
                  <p className="cfg-display text-4xl text-[#D4AF37] leading-none mt-1">€{r.price.toFixed(0)}</p>
                  <p className="cfg-body text-[#071B2F]/40 text-xs mt-1">{a.allin}</p>
                </div>
                <button onClick={() => book(r, current)} data-testid={`airport-book-${current.airport}-${r.city}`}
                  className="cfg-body opacity-80 group-hover:opacity-100 inline-flex items-center gap-2 rounded-full border border-[#071B2F]/20 group-hover:border-[#D4AF37] text-[#071B2F] text-[10px] tracking-widest uppercase px-4 py-3 transition-colors">
                  {a.book}<ArrowRight weight="light" size={14} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
